/**
 * Hub Service by karora on 11/03/17.
 */
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import {Observable, ReplaySubject, Subject} from 'rxjs';

import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { StandardResponse } from '../types/standard-response';
import { throwError } from 'rxjs/internal/observable/throwError';
import {Router} from '@angular/router';

import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { allResolved } from 'q';
import { LeadDetails } from '../types/leads';
import { ApiService } from '../services/api.service';

@Injectable()
export class WebService {
  private baseURL = 'signup_form';

  constructor(
    private api: ApiService,
  ) { }

  submitEmail(email: String) {
    console.log('submitEmail()');
    console.log(email);
    let url = `${this.baseURL}`;
    console.log(url);
    return this.api.Put(url, JSON.stringify(email));
  }

  submitSignUp(signup: LeadDetails): Observable<any> {
    return this.api.Put("/upload", JSON.stringify(signup));
  }

  updateSignUp(signup: LeadDetails): Observable<any> {
    return this.api.Put("/update", JSON.stringify(signup));
  }

  getLeads(hash: string): Observable<LeadDetails[]> {
    return this.api.Get("/lead_details/", hash)
      .map(WebService.leadsExtract)
      .catch(WebService.fetchError);
  }

  getSignUps(hash: string): Observable<LeadDetails[]> {
    return this.api.Get("/signup_details/", hash)
      .map(WebService.leadsExtract)
      .catch(WebService.fetchError);
  }

  private static leadsExtract(body: StandardResponse): any {
    if (body.status === 'error') {
      throw new Error(body.data.message);
    }
    return body.data || {};
  }

  private static fetchError(error: HttpErrorResponse): Observable<any> {
    let errMsg: string;
    const body = error.error.json() || '';
    const err = body.data.error || JSON.stringify(body);
    errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    console.error(errMsg);
    return throwError(errMsg);
  }
}


